// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".midget-container{display:flex;flex:1;flex-direction:row}@media(max-width:600px){.midget-container{flex-direction:column}}", ""]);
// Exports
module.exports = exports;
